import { MenuItem } from '@/types/sidebar.type';
import { hasAccess } from '@/state/store/auth/use-is-protected';

const toArray = (value?: string | string[]) => (value === undefined ? [] : [value].flat());

type MenuAccess = {
  user: Parameters<typeof hasAccess>[0]['user'];
  organizationId: string | null;
};

/**
 * Keeps the menu items the user can open. An item without `roles`/`permissions` is open to
 * everyone; a parent whose children are all hidden is hidden too.
 */
export const filterMenuItems = (menuItems: MenuItem[], { user, organizationId }: MenuAccess) => {
  const filterMenuItem = (item: MenuItem): MenuItem | null => {
    const roles = toArray(item.roles);
    const permissions = toArray(item.permissions);
    const isRestricted = roles.length > 0 || permissions.length > 0;

    if (isRestricted) {
      const allowed = hasAccess({
        user,
        organizationId,
        roles,
        permissions,
        opt: item.requireBoth ? 'all' : 'any',
      });
      if (!allowed) return null;
    }

    if (!item.children) return item;

    const children = item.children.map(filterMenuItem).filter(Boolean) as MenuItem[];
    return children.length > 0 ? { ...item, children } : null;
  };

  return menuItems.map(filterMenuItem).filter(Boolean) as MenuItem[];
};
